import { css } from '@flipster/styled-system/css';
import ArrowRightIcon from '@flipster/ui/assets/svgs/arrow-right.svg';

import { PageLinkProps } from '../../types';

export const PageLink = ({ page, per, total, onChange, getPageHref }: PageLinkProps) => {
  const isFirstPage = page === 0;
  const isLastPage = total <= (page + 1) * per;

  if (isFirstPage && isLastPage) return null;

  return (
    <div className={wrapperStyle}>
      <a
        href={getPageHref(page - 1)}
        className={css(linkStyle, leftStyle)}
        onClick={(e) => {
          e.preventDefault();
          if (!isFirstPage) onChange(page - 1);
        }}
        aria-disabled={isFirstPage}
        aria-label='prev'
        rel='prev'
      >
        <ArrowRightIcon />
      </a>
      <a
        href={getPageHref(page + 1)}
        className={css(linkStyle)}
        onClick={(e) => {
          e.preventDefault();
          if (!isLastPage) onChange(page + 1);
        }}
        aria-disabled={isLastPage}
        aria-label='next'
        rel='next'
      >
        <ArrowRightIcon />
      </a>
    </div>
  );
};

const wrapperStyle = css({ display: 'flex', alignItems: 'center', gap: 8 });

const linkStyle = css.raw({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: 32,
  h: 32,
  color: 'inverse.white',
  '&[aria-disabled="true"]': {
    color: 'content.default.level-1',
    pointerEvents: 'none',
  },
});

const leftStyle = css.raw({ '& svg': { transform: 'rotate(180deg)' } });
